const focus = {
	inserted: function(el) {
		el.focus();
	}
};
export default focus;



// WEBPACK FOOTER //
// ./src/shared/directives/Focus.ts